var zh_cn = {
  Video_CONFERENCE_HOME_NAME: "263云视",
  Video_CONFERENCE_MEETING_NAME: "的会议",
  JOINING_ROOM: "正在进入",
  PLEACE_INPUT_NAME: "请输入参会人姓名",
  PLEACE_INPUT_ID: "请输入会议ID",
  LOGIN_FAILER_INFO_ABOUT_ACCOUNT: "账号或密码错误",
  LOGIN_FAILER_INFO_ABOUT_NET: "进入会议失败，请检查网络设置",
  LOGIN_FAILER_INFO_ABOUT_OTHER: "登录失败，请稍后再试",
  LOGIN_FAILER_INFO_INVALIED: "登录状态已经失效，请重新登录",
  LOGIN_PLACEHOLDER_ACCOUNT: "输入用户名",
  LOGIN_PLACEHOLDER_PASSWORD: "输入密码",
  LOGIN_PLACEHOLDER_PARCITIPANT_NAME: "参会人姓名",
  LOGIN_PLACEHOLDER_ROOMEID: "会议ID",
  LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT: "会议未开始或不存在",

  LOGIN_FAILER_INFO_JOINROOMFAILE: "加入会议失败，请稍后再试",
  LOGIN_NAME: "用户登录",
  ADMINER_LOGIN_NAME: "系统管理员登录",
  CLOSE_NAME: "关闭",
  PARTICIPATE_MEET: "参加会议",
  LOGIN_FOOTER_NAME: `Copyright © 1998-${new Date().getFullYear()} 北京二六三企业通信有限公司`,
  LOGOUT_INFO: "您的账号已在另一台设备登录，本端已退出!",
  USERINFO_IS_DELETED: "您的账号已被删除或禁用",
  LOGIN_INFO_CHANNGE: "登录信息发生变化，请重新入会",
  SPONSOR_MEET: "发起会议",
  HOST_MYSELF_MEET: "主持自己的会议",
  PARTICIPATE_OTHERS_MEET: "参加别人的会议",
  PARTICIPATE_OTHERS_MEET_PLACEHOLDER: "请输入会议ID",
  JOIN_ROOM: "加入会议",
  JOIN_ROOM_LOADING_NAME: "正在进入会议室",
  JOIN_ROOM_FAILER_NET: "进入会议失败，请检查网络设置",
  JOIN_ROOM_FAILER_OTHER: "进入会议失败，请稍后再试",
  JOIN_ROOM_FAILER_ROOMID: "会议不存在，请确认会议ID是否正确",
  JOIN_ROOM_RESUME_LOADING: "正在重新进入会议...",
  JOIN_ROOM_RESUME_NET_LOADING: "加载中...",
  NET_ONLINE_TIPS: "正在重连网络",
  NET_OFF_TIPSLINE: "当前网络不可用，请检查您的网络设置",
  FAILED_NAME: "失败",
  CANCEL_NAME: "取消",
  CONFIRM_NAME: "确定",
  UP_ONE_STEP: "上一步",
  TIPS_NAME: "提示",
  KOWM_NAME: "我知道了",
  REMIND_NAME: "提醒",
  REJECT_NAME: "拒绝",
  ANSWER_NAME: "接听",
  HANGUP_NAME: "挂断",
  EXIT_NAME: "退出",
  LOCAL_NAME: "本地",
  MEET_NAME: "会议",
  SHARE_NAME: "共享",
  RELOGIN_NAME: "重新登录",
  EXIT_LOGIN: "退出登录",
  EXIT_LOGIN_CONFIRM: "您确定要退出登录吗",
  INVITE_JOIN_TIPSINFO: "邀请你参加会议",
  SET_NAME: "设置",
  DEVICE_INFO: "设备信息",
  MIC_NAME: "麦克风",
  UNMIC_NAME: "未检测到麦克风",
  LOADSPEAKER_NAME: "扬声器",
  CAMERA_NAME: "摄像头",
  UNCAMERA_NAME: "未检测到摄像头",
  MUTE_NAME: "静音",
  UNMUTE_NAME: "解除静音",
  NO_NAME: "无",
  UN_USEFUL: "不可用",
  NO_CAMERA: "暂无摄像头",
  AUDIO_TEST: "测试音频",
  STOP_AUDIO_TEST: "停止测试",
  SET_MEETING: "会议设置",
  VIDEO_QUALITY: "视频发送质量",
  SHARE_QUALITY: "共享发送质量",
  VIDEO_SEND_RESOLUTION: "视频发送分辨率",
  AUTO_NAME: "自动",
  QUALITY_PRIOR: "质量优先",
  FLUENT_PRIOR: "流畅优先",
  JOIN_ROOM_MSG_TIPS: "参会人入会消息提示",
  EXIT_ROOM_MSG_TIPS: "参会人退会消息提示",
  MEETCHAT_MSG_TIPS: "聊天室消息提示",
  ACCOUNT_NAME: "账号",
  SHOW_NAME: "显示姓名",
  ABOUT_NAME: "关于",
  BETA_INFO: "Beta  v1.0.0",
  ROOM_MUTE: "会议静音",
  ROOM_UNMUTE: "解除静音会议",
  //SETING_ROOM_MUTE:'您正在设置会议室静音',
  //SETING_ROOM_UNMUTE:'您正在取消会议室静音',
  MEET_CONTROL_TIPS_ROOM_MUTE: "会议室已开启静音状态",
  MEET_CONTROL_TIPS_ROOM_UNMUTE: "会议室已解除静音状态",
  MEET_CONTROL_TIPS_AUDIO_CLOSE: "声音关闭",
  MEET_CONTROL_TIPS_AUDIO_OPEN: "声音开启",
  MEET_CONTROL_TIPS_VIDEO_CLOSE: "视频关闭",
  MEET_CONTROL_TIPS_VIDEO_OPEN: "视频开启",
  MEET_CONTROL_TIPS_RECORD_OPEN: "开始录像",
  MEET_CONTROL_TIPS_RECORD_STOP:
    '确定要结束录像吗？&#10;<span style="color:#999">您可以在本场会议的详情中查看此次录像。</span>',
  MEET_CONTROL_TIPS_RECORD_OPEN_FAILED: "开始录像失败",
  MEET_CONTROL_TIPS_RECORD_CLOSE: "录像结束",
  MEET_CONTROL_TIPS_RECORD_CLOSE_FAILED: "录像结束失败",
  STOP_RECORD: "停止录像",
  MEET_CONTROL_TIPS_ROOM_MUTE_HOST: "主持人已将会议置于静音状态",
  MEET_CONTROL_TIPS_ROOM_UNMUTE_HOST: "主持人已解除会议静音状态",
  MEET_MUTE_FAILED: "会议静音失败",
  MEET_UNMUTE_FAILED: "会议解除静音失败",
  MUTE_CLOSE_FAILED: "声音关闭失败",
  MUTE_OPEN_FAILED: "声音开启失败",
  MEET_CONTROL_TIPS_AUDIO_CLOSE_HOST: "您已被主持人静音",
  MEET_CONTROL_TIPS_AUDIO_OPEN_HOST: "静音状态已解除",
  RECORD_OPEN: "会议已开始录像",
  RECORD_CLOSE: "会议结束录像",
  MEET_CONTROL_RECORDING: "会议处于录像状态",
  HOST_LEAVE_MEET_TIPS:
    "离开会议时，建议您将主持人权限从参会人列表中转移给其他人，结束会议请直接点击结束。",
  PARTICIPATE_LEAVE_MEET_TIPS: "确定退出会议吗？",
  EXIT_MEET_NAME: "退出会议",
  PLEASE_OUT_MEET: "请出会议",
  LEAVE_MEET_NAME: "离开会议",
  OVER_MEET_NAME: "结束会议",
  DESKTOP_SHARE_NAME: "桌面共享",
  PARTICIPATE_NAME: "参会人",
  MEET_CONTROL_NAME: "会控",
  FULL_SCREEN_NAME: "全屏",
  EXIT_FULL_SCREEN_NAME: "退出全屏",
  CLEAR_SCREEN_NAME: "清屏",
  CLEAR_SCREEN_TIPS: "确定要清除我的所有标注吗？",
  OTHER_SHARE_TIPS: "正在共享，您发起共享后，对方将自动退出。",
  SOMEBODY_ISSHAREIN: "正在共享...",
  SELF_SHAREING: "您正在共享中",
  JOINING_NAME: "您已在会中",
  EXIT_CURRENT_CONFERENCE: "您已在会中，请退出当前会议后再加入新的会议",
  LOGIN_OUT_OTHER_POINT: "您的账号已在会中，是否要将其踢掉并使用本端入会。",
  OTHER_POINT_JOIN_ROOM: "该账号已在其他端入会，您已退出会议",
  GOON_SHARE: "继续共享",
  OVER_SHARE: "结束共享",
  GIVEUP_SHARE: "放弃共享",
  FORBID_SHARE: "禁止共享",
  EMPOWER_SHARE: "授权共享",
  SHARE_TIPS_NAME: "共享提示",
  SHARE_APPLY_NAME: "共享申请",
  SHARE_APPLY_POWER_TIPS: "会议室已禁止共享，是否向主持人申请共享？",
  SHARE_APPLY_PART_POWER_TIPS: "主持人已禁止您共享，是否向主持人申请共享？",
  CHROME_UPGRADE:
    "当前chrome版本不支持桌面共享功能，请更新chrome到72及以上版本",
  SUPPORT_SHARE_NAME:
    "当前浏览器不支持共享，请使用最新版本的Chrome或火狐浏览器",
  HOST_UPGRADE: "您已被指定为当前会议的主持人",
  MEEE_ISOVER: "会议已结束",
  LEAVE_MEET_BY_HOST: "您已被主持人请出会议",
  LEAVE_MEET_ALREADY_NAME: "您已离开会议",
  HIDE_SMALL_VIDEO: "隐藏小视频",
  SPONSOR_SHARE: "正在发起共享",
  NEW_SHARE_ISRECEIVED: "发起了新的共享，您的共享已自动停止。",
  ERASER_NAME: "橡皮擦",
  CLEAR_MYSELFT_POSTIL: "清除我的所有标注",
  DEVICE_OCCUPY: "您选择的设备已经被占用，请选择其他设备",
  DEVICE_REJECE: "您已经禁止当前设备的使用，请前往浏览器的权限设置允许使用",
  DEVICE_NOFOUND: "没有发现设备，请检查电脑是否存在可用设备",

  RECEIVE_SHARE_TIPS: function (name) {
    return `正在接收<span class="share_name">${name}</span>发起的共享`;
  },
  RECEIVEING_SHARE_TIPS: "正在接收",
  SPONSOR_SHAERL: "发起的共享",
  CALL_OUT_PARTICIPANT: "呼叫参会人",
  NO_OTHER_PARTICIPANT: "暂无其他联系人",
  ASSIGN_PARTICIPANT: "指定参会人",
  ASSIGN_NAME: "指定",
  ALREADY_ASSIGN_NAME: "已指定",
  INPUT_LIMIT_NUMBER: "会议已达人数上限",
  HANDLE_FAILER_TIPS: "操作失败，请稍后再试",
  ASSIGIN_FAILED: "指定参会人失败",
  OPEN_MUTE_JOINROOM: "打开静音入会",
  CLOSE_CAMERA_JOINROOM: "关闭摄像头入会",
  HOST_LOCK_PLEACE_APPLY_JOINROOM: "主持人已将会议锁定，请申请入会",
  APPLY_JOINROOM: "申请入会",
  AWAIT_APPLY_RESULT: "申请已提交，等待主持人同意...",
  REJECT_ALLPY: "主持人拒绝了你的入会申请",
  MORE_NAME: "更多",
  ALREADY_JOIN_ROOM_NAME: "已入会",
  NO_JOIN_ROOM_NAME: "未入会",
  MEET_CHAT_NAME: "聊天室",
  INVITE_PART_NAME: "邀请参会人",
  COPY_INVITE: "复制参会邀请",
  RECORD_NAME: "录像",
  RECORDING_NAME: "正在录像...",

  OPEN_RECORD_PERMISSION: "尚未开通此功能，请联系企业管理员",
  INCREASE_RECORD_SPACE: "存储空间已耗尽，请联系企业管理员充值",

  LAYOUT_NAME: "布局",
  IGNORE_ALL_APPLY_NAME: "忽略所有申请",
  IGNORE_NAME: "忽略",
  ALL_IGNORE_NAME: "全部忽略",
  SEARCH_NAME: "搜索",
  HOST_NAME: "主持人",
  PC_JOIN_ROOM_NAME: "PC端入会",
  WEB_JOIN_ROOM_NAME: "WEB端入会",
  ANDROID_JOIN_ROOM_NAME: "Android端入会",
  TOUCH_JOIN_ROOM_NAME: "Touch端入会",
  BOX_JOIN_ROOM_NAME: "硬件终端入会",
  IOS_JOIN_ROOM_NAME: "IOS端入会",
  VIDEO_MEET_JOIN_ROOM_NAME: "视频会议入会",
  APPLY_NAME: "申请",
  TOP_NAME: "置顶",
  CANCEL_TOP_NAME: "取消置顶",
  MORE_HANDLE_NAME: "更多操作",
  SET_VIDEO_LAYOUT_NAME: "视频布局设置",
  ONE_WAY_LAYOUT_NAME: "一路",
  TWO_WAY_LAYOUT_NAME: "二路",
  THREE_WAY_LAYOUT_NAME: "三路",
  FOUR_WAY_LAYOUT_NAME: "四路",
  SIX_WAY_LAYOUT_NAME: "六路",
  EIGHT_WAY_LAYOUT_NAME: "八路",
  NINE_WAY_LAYOUT_NAME: "九路",
  TEN_WAY_LAYOUT_NAME: "十路",
  THIRTEEN_WAY_LAYOUT_NAME: "十三路",
  SIXTEEN_WAY_LAYOUT_NAME: "十六路",
  SANSHI_SECOND_NAME: "30秒",
  LIUSHI_SECOND_NAME: "60秒",
  JIUSHI_SECOND_NAME: "90秒",
  AUTO_LOOPTIME_NAME: "自动轮巡时间",
  LOCK_ROOM_NAME: "锁定会议室",
  PERMIT_SHARE_NAME: "允许所有人共享",
  ALREADY_PERMIT_SHARE_NAME: "已允许所有人共享",
  ALREADY_FORBIT_ALL_SHARE_NAME: "已禁止参会人共享",
  FORBIT_SHARE_NAME: "已禁止共享",
  PERMIT_SHARE_NAM: "已授权共享",
  HOST_PERMIT_SHARE_NAME: "主持人已授权您共享",
  HOST_FORBIT_SHARE_NAME: "您已经被主持人禁止共享",
  MEET_PERMIT_SHARE_NAME: "会议允许所有人共享",
  MEET_FORBIT_SHARE_NAME: "会议禁止所有人共享",
  FORBIT_PART_SHARE_FAILED: "禁止参会人共享失败",
  PERMIT_PART_SAHRE_FAILED: "允许所有人共享失败",
  FORBIT_SHARE_FAILED: "禁止共享失败",
  PERMIT_SHARE_FAILED: "授权失败",
  FORBIT_NOTE_FAILED: "禁止标注失败",
  PERMIT_NOTE_FAILED: "解除禁止标注失败",

  SPONSOR_SHAERLER_FORBIT_NOTE: "共享发起人禁止标注",
  SPONSOR_SHAERLER_PERMIT_NOTE: "共享发起人允许所有人标注",
  ALREADY_SELECT_NAME: "已选择",
  PART_NUM_NAME: "个参会人",
  NO_FOUND_NAME: "没有找到参会人",
  NO_FOUND_PART: "没有搜到相关结果",
  COPY_ROOM_INFO: "复制会议信息",
  PERMIT_MEET_NAME: "允许聊天",
  SEND_NAME: "发送",
  ME_NAME: "我",
  COPY_NAME: "复制",
  COPY_SUCCESS_NAME: "复制成功",
  COPY_FAILED_NAME: "复制失败",
  NO_PART_OR_NO_CAMERA: "找不到参会人或者 参会人未开启摄像头",
  CALL_MANY_PEOPLE_NAME: "呼叫多人",
  CANCEL_ALL_CALL_NAME: "取消所有呼叫",
  AGREE_NAME: "同意",
  CANCEL_CALL_NAME: "取消呼叫",
  IS_CANCEL_ALL_NAME: "是否取消对所有人的呼叫？",
  CALLING_NAME: "（呼叫中）",
  ALREADY_REJECT_NAME: "（已拒绝）",
  BUSYLINE_NAME: "（占线中）",
  ALREADT_CANCEL_NAME: "（已取消）",
  ALREADY_LEAVE_NAME: "（已离会）",
  NO_RESPONSE_NAME: "（无应答）",
  ATONCE_CALL_NAME: "立即呼叫",
  CALL_FAILED: "呼叫失败",
  CANCEL_CALL_FAILED: "取消呼叫失败",
  MEET_NOTICE_NAME: "【会议邀请】",
  CLICK_JOIN_ROOM: "点击入会",
  MEET_TIME: "会议时间",
  TRANSFER_HOST_IDENTITY: "转移主持人身份",
  CONFIRM_TRANSFER_HOST_IDENTITY: "确定要转移主持人身份吗?",
  TRANSFER_HOST_FAILED: "转移主持人身份失败",
  SPEAK_APPLY: "发言申请",
  HOST_MUTE_APPLY: "会议室已静音，是否向主持人申请发言？",
  HOST_MUTE_PART_APPLY: "主持人已将您静音，是否向主持人申请发言？",
  NOTE_NAME: "标注",
  HOST_CLOSE_ALL_NOTE_POWER: "共享发起人已禁止标注",
  CLOSE_MIC_NAME: "关闭麦克风",
  OPEN_MIC_NAME: "打开麦克风",
  CLOSE_CAMERA_NAME: "关闭摄像头",
  OPEN_CAMERA_NAME: "打开摄像头",
  SPEED_NAME: "速率",
  SEND_PACKET_NAME: "发送包",
  LOST_PACKET_NAME: "丢包",
  LOST_PACKET_RATE_NAME: "丢包率",
  RESOLUTION_NAME: "分辨率",
  FRAME_RATE_NAME: "帧率",
  CODEC_NAME: "编解码",
  DECODE_NAME: "解码",
  DECODE_DELAY_NAME: "解码延迟",
  RECEIVE_PACKET_NAME: "接收包",
  ENCODED_DELAY_NAME: "编码延迟",
  VIDEO_SEND_NAME: "视频发送",
  AUDIO_SEND_NAME: "音频发送",
  SHARE_VIDEO_SEND_NAME: "共享视频发送",
  SHARE_VIDEO_RECEIVE_NAME: "共享视频接收",
  SHARE_AUDIO_RECEIVE_NAME: "共享音频接收",
  VIDEO_RECEIVE_NAME: "视频接收",
  AUDIO_RECEIVE_NAME: "音频接收",
  CONNECT_SIGNAL: "连接信号",
  KPBS_NAMS: "kbps",
  LOADING_NAME: "加载中",
  LOAD_FAILE_NAME: "加载失败，请稍后重试",
  ALREADY_SHOW_ALL_NAMW: "已经全部显示了...",
  LATERON_SEND_NAME: "您的发言太快，请稍后再发",
  NUM_NEWMSG_TIPS_NAME: "条新消息",
  BROWSER_COMPATE_TIPS_NAME:
    "当前浏览器有兼容性问题，请使用最新版本的Chrome或火狐浏览器",
  CHANGE_MIC_DEVICE_NAME: "切换麦克风设备",
  CHANGE_SPEAKER_DEVICE_NAME: "切换扬声器设备",
  CHANGE_CAMERA_DEVICE_NAME: "切换摄像头设备",
  OPEN_MAX_RESOLUTION: "已开通的最高分辨率：",
  // CONTACR_ADMINISTRATOR:'未开通，请联系企业管理员',
  ON_OPENED_NAME: "（未开通）",
  CUSTOMER_SERVICE_CALL: "客服热线：400-650-9263",
  ALREADY_PASS_REG: "已通过ISO20000和ISO27001认证",
  ALL_RIGHT_RESERVED: "版权所有",
  COMPANY_NAME: "北京二六三企业通信有限公司",
  COPYRIGHT_NAME: `Copyright©1998-${new Date().getFullYear()}`,
  ANDROID_NAME: "Android",
  IPHONE_NAME: "iPhone",
  WINDOWS_NAME: "Windows",
  MOBILE_TERMINAL: "移动端",
  ROOM_FULL_NAME: "进入会议失败，会议已满员，请联系主持人或稍后再试",
  APPLY_SPEAK: "申请讲话",
  APPLY_SHARE: "申请共享",
  SPEAKING: "正在讲话",
  PHONE_JOINER: "电话方",
  MEET_SET_FORBIT_CHAT: "会议设置为禁止聊天",
  MEET_SET_PERMIT_CHAT: "会议设置为允许聊天",
  NOT_OPEN_FUNCTIONE: "尚未开通此功能，请联系企业管理员",
  PART_WILL_DESTROY_TIPS: "主持人不在会中，会议将于5分钟后结束",
  HOST_WILL_DESTROY_TIPS: "只有您一人在会中，会议将于5分钟后结束",
  APPLY_BUSY: "你的申请太过于频繁，请稍候再申请。",
  DIAABLE_MIC_CAMERA_TIPS:
    "无法连接到摄像头或麦克风，请检查您的摄像头或麦克风是否连接或被其他应用占用。",
  // DEVICE_NOT_ALLOWED_TIPS:'麦克风或摄像头被禁用，请点击浏览器地址栏左侧【加锁】将摄像头和麦克风设置为“允许”。',
  // DEVICE_NOT_READABLE_TIPS:'麦克风或摄像头被操作系统禁用或被其他应用程序占用，请检查您的配置。',
  // DEVICE_NOT_FOUND_TIPS:'未检测到摄像头或麦克风，请检查设备是否正常连接。',
  CHANGE_DEVICE_NOT_ALLOWED_TIPSL:
    "麦克风或摄像头被禁用，请点击浏览器地址栏左侧【加锁】将摄像头和麦克风设置为“允许”。",
  CHANGE_DEVICE_NOT_READABLE_TIPS:
    "1 请检查摄像头或麦克风是否被其他软件占用；\n" +
    "2 请检查Windows系统设置—>隐私—>相机/麦克风—>允许应用访问你的相机/麦克风—>开启",
  CHANGE_DEVICE_NOT_FOUND_TIPS:
    "1 请检查摄像头或麦克风是否连接正常；\n" +
    "2 请检查Windows设备管理器中，摄像头或麦克风是否被禁用",
  AUTO_LAYOUT: "自动布局",
  LAYOUT_SET_NAME: "布局设置",
  EQUAL_SCREEN_LAYOUT: "等分屏布局",
  FOCUS_LAYOUT: "焦点布局",
  RECOMMEND_NAME: "（推荐）",
  SELECT_AUTO_LAYOUT: "确定要使用自动视频布局吗？",
  INVITE_REACH_LIMIT_TIPS: "你选择的参会人超出最大邀请数，请重新选择",
  PEOPLE_NAME: "人",
  MEET_NAME: "会中",
  JOINR_NAME: "进入",
  LEAVE_NAME: "离开",
  APPLY_MANAGE: "申请管理",
  USER_AGREEMENT: "《用户协议》",
  PRIVACY_POLICY: "《隐私政策》",
  MAC_SHARE_PERMISSION_TIPS:
    "您的浏览器没有获得系统的 “屏幕录制”权限，请在【系统偏好设置】—>【安全性与隐私】—>【隐私】—>【屏幕录制】，勾选您所使用的浏览器后，重新发起共享。",
  NET_BAD_TIPS: "网络环境较差，建议切换网络",
  WINDOW_INSTALL_HREF: "https://simupdate.263.net/yspcupdate/263Vision.exe",
  IOS_INSTALL_HREF: "https://apps.apple.com/cn/app/id1487354600",
  ANDROID_INSTALL_HREF: "https://simupdate.263.net/ysandroid/263Vision.apk",
  USER_AGREEMENT_HREF: "https://www.263.net/263/agreement/terms/",
  PRIVACY_POLICY_HREF: "https://www.263.net/263/agreement/policy/",
  OFFICIAL_WEBSITE_ADDRESS: "https://www.263.net/",
  CSD_HREF:
    "https://net263.s4.udesk.cn/im_client/?web_plugin_id=26753&group_id=28142",
  CUSTOMER_SERVICE: "在线客服",
  VISIONINSERT: "云视接入",
  PHONEINSERT: "电话接入",
  PLEASE_INPUT_NAME: "请输入姓名",
  SYSTEM_NAT_ALLOW_CALL: "系统不允许外呼",
  INPUT_RIGHT_PHONE:
    "您输入的号码格式有误，请参考以下示例输入：\n" +
    "国内号码输入格式：手机号码/区号固定电话-分机号码手机号码\n" +
    "输入：直接输入手机号码，如：136********；\n" +
    "座机号码输入：区号座机号码-分机号码，如：01081740263-1234。\n" +
    "国际号码输入格式：00+国家代码+区号+手机/固定电话\n" +
    "例如：美国固定电话0013235447799",
  ALREADY_SELECT_PARTS: "您已经选择此参会人",
  USER_NOT_PHONE_CODE: "此用户无电话号码",
  SHOW_MIC_VOICE: "显示麦克风音量",
  VOICE_STIMULATION: "语音激励",
  VOICE_STIMULATION_OPEN_FAIL: "语音激励开启失败",
  VOICE_STIMULATION_CLOSE_FAIL: "语音激励关闭失败",
  MIC_UNUSABLE: "云视检测到您当前麦克风设备不可用,请更换设备",
  CAMERA_UNUSABLE: "云视检测到您当前摄像头设备不可用,请更换设备",
  MIC_AND_CAMERA_UNUSABLE:
    "云视检测到您当前麦克风和摄像头设备不可用,请更换设备",
  ENTER_ROOM: "进入会议",
  RESOLUTION_TIPS:
    "您所选的分辨率为发送的最高分辨率，如果网络或设备性能不足，会自动降低分辨率",
  INVITE_NOW_NAME: "立即邀请",
  ADD_PHONE_NUMBER_NAME: "手动添加电话",
  WEBCONF_INVITE_NAME: "云视邀请",
  TELCONF_INVITE_NAME: "电话外呼",
  TELCONF_CODE: "区号/固定号码/手机号码",
  EXTENSION_CODE: "分机号码",
  ADD_NAME: "添加",
  AUTO_DEFAULT_NAME: "自动(默认)",
  CHINESE_NAME: "中文",
  ENGLISH_NAME: "英文",
  CLOSETIPS: "关闭提醒",
  CALL_VIDEO_MEET: "呼叫263视频会议",
  ADD_SIP: "添加sip终端",
  VIDEO_MEET_PASSWORD: "263视频会议的入会密码：",
  INPUT_NUMBER: "请输入6～10位纯数字",
  CALL: "呼叫",
  SET_STREM_TO_PEXIP: "设置回传视频",
  SELECT_STREM_TO_PEXIP: "请选择回传到263视频会议的视频：",
  JOIN_PEXIP_MEET_CONTROL: "进入视频会议会控",
  CHANGE: "切换",
  PASSCODE_INVALID: "入会密码无效",
  ALREADT_HANGUP: "已挂断",
  REMARKES_VIDEO_MEET:
    "备注：若所选的参会人的视频关闭或离会后，将自动切换为会议视频。",
  MEET_VIDEO: "会议视频",
  VIDEO_MEET: "视频会议",
  LIVE_NAME: "直播助手",
  REGAIN_HOST_PRIVILEG: "收回主持人权限",
  JOIN_INVITE: "入会邀请",
  NOTMUTE: "不可静音视频会议",
  SET_STREAM_TO_PEXIP_YES: "切换成功",
  SET_STREAM_TO_PEXIP_NO: "切换失败",
  SERVER_ERROR: "服务异常，请重试",
  NET_ERROR: "网络异常，请重试。",
  JOIN_ROOM_ADDR: "参会人入会地址",
  HOST_JOIN_ROOM_ADDR: "主持人入会地址",
  SCANQR_JOIN_ROOM: "扫码加入会议",
  NOT_CONTAIN_HOST_URL: "入会信息，不包含主持人链接",
  LIVE_NAME: "直播助手",
  OLD_HOST_PASSWORD: "使用主持人地址入会，已成为本场会议主持人。",
  RETRIEVE_HOST: "已收回主持人身份。",
  JOINER_URL: "参会人地址",
  HOST_URL: "主持人地址",
  RECEOVE_HOST_ERR:
    "获取主持人身份失败，如需主持人身份，请使用主持人地址重新入会。",
  INVITE_SEARCH: "请输入姓名、手机号、ID",
  CALL_PHONE_CONTENT: "输入手机号添加成员。添加后，点击确定将呼",
  GOON_ADD: "继续添加",
  INVITE: "邀请",
  NO_DATA: "暂无数据",
  ASSIGIN: "指定为",
  SHARE_DOC: "文档窗",
  SHARE_SCREEN: "共享窗",
  MIX: "视频窗",
  ALLOW_MOTIFY_NAME: "允许参会人改名",
  MOTIFY_NAME: "修改姓名",
  INPUT_NAME: "输入名称",
  JOIN_MEET_CONTROL: "会控助手",
  SEARCH_RESULT: "搜索结果",
  SEPAK_SOMEING: "说点什么吧",
  NOT_MEET_CONTENT: "暂无聊天信息",
  VIDEO_JOIN_MEET: "视频入会",
  PHONE_JOIN_MEET: "电话入会",
  LIVE_VIEW: "直播观看",
  HOST_JOIN_PSD: "主持人入会密码",
  CONFERREEN_JOIN_PSD: "参会人入会密码",
  ACCESS_NUMBER: "会议接入号",
  OVERSEAS_ACCESS_NUMBER: "海外接入号",
  LIVE_THEME: "直播主题",
  LIVE_VIEW_ADDR: "观看地址",
  SAVE_QRCODE: "点击二维码保存",
  DOC_SHARE: "文档共享",
  MEET_IS_LOCK: "会议已锁定",
  OVERSEAS_ACCESS_NUMBER_SRC: "https://download.263.net/access/",
  PARTY_NUMBER_REPEAT: "手机号重复",
  MOTIFY_ERR: "修改失败",
  EXIT_LINK: "你有待添加的联系人",
  NOT_ADD: "不添加",
  CONTINUE_ADD: "继续添加",
  SHARE_END: "已经结束当前共享文档",
  NOT_PARTIES: "无参会人",
  PARTIES_ISLEAVE: "参会人已离开",
  VIDEO_ISCLOSEL: "视频已关闭",
  PART_SEARCH: "搜索参会人姓名、手机号",
  MEET_DURATION: "会议时长",
  PLEASE_INPUT_RIGHT_PHONE_sNUMBER: "请输入正确的手机号",
  HOST_END_SHARE_TIPS: "主持人结束了共享，您的共享已自动退出",
  HOST_HANGUP: "被主持人挂断",
  PARTICIPANT_HANGUP: "参会人主动挂断",
  SYSTEM_NOT_ALLOW_CALL: "系统不允许外呼",
  MIN_NAME: "分钟",
  DOUBLE_SCREEN_TIPS:
    "开启双共享模式，将会占用参会人较高的硬件设备性能，确认开启吗?",
  INTERCUT_SHARE: "插播共享",
  PAUSE_PLAY: "暂停播放",
  START_PLAY: "开始播放",
  YOU_SHARING_INTERCUT: "您正在共享插播",
  STOP_SHARE: "停止共享",
  SHARING_INTERCUT: "正在共享插播",
  LIST_LOOP: "列表循环",
  SINGLE_LOOP: "单个循环",
  SINGLE_PLAY: "单个播放",
  ALREADY_FIRST: "已经是第一个啦",
  ALREADY_LAST: "已经是最后一个啦",
  MOVE_NAME: "拖拽",
  PRE_NAME: "上一个",
  NEXT_NAME: "下一个",
  LIST_NAME: "列表",
  PLEASE_INPUT_SIP_CODE: "请输入SIP账号",
  CAST_SCREEN: "无线投屏",
  REPORT_PHONE: "举报电话：",
  REPORT_EMAIL: "举报邮箱：",
  GROUP_DISCUSS: "分组讨论",
  CREATE_NAME: "创建",
  RANDOM_DISTRIBUTION: "随机分配",
  MANUAL_DISTRIBUTION: "手动分配",
  PRE_DISTRIBUTION: "使用预分组",
  PRE_DISTRIBUTIONTIPS: "使用此会议预先设置的分组",
  GROUP_NUMBER: "讨论组数量",
  GROUP_MEMBER: "讨论组成员",
  GROUP_TIPS: "该场会议最多支持15个分组",
  GROUP_TIPSPRE: "如需修改可在创建分组后调整",
  RANDOM_TIPS: "将会场人数按照分组数量随机平均分配到组内",
  MANUAL_TIPS: "需主持人手动分配主会场参会人至各个分组",
  ALLOW_FREE_SELECT: "允许参会人自由选择",
  NEED_AGREE_JOINED: "需要参会人同意后入组",
  PLEASE_INPUT_RIGHT_NUMBER: "请输入正确数字",
  RECREATE: "重新创建",
  ADD_DISCUSS: "添加讨论组",
  START_DISCUSS: "开始讨论",
  DISTRIBUTION: "分配",
  GROUP_HOST: "分组主持人",
  SET_GROUP_HOST: "设置分组主持人",
  MOVE_TO: "移动至",
  DELETE: "删除",
  RENAME: "重命名",
  IS_CONFIRME_DELETE_GROUP: "确定删除当前讨论组吗",
  NO_DISTRIBUTION: "未分配",
  NO_START: "尚未开始",
  ONGOING: "进行中",
  RE_CREATE_TIPS: "所有创建好的讨论组都将被替换",
  NO_JOINER: "未加入",
  ISLEAVE: "已离开",
  ALREADY_JOINED: "已加入",
  JOINED: "加入",
  EDN_DISCUSS: "结束讨论",
  SEND_ALL_MSG: "发送全体消息",
  JOIN_DISTRIBUTION: "加入讨论组",
  HOST_INVITE_YOU: "主持人邀请您加入",
  PLEASE_HELP: "请求帮助",
  YOU_CAN_PLEASE_HELP: "您可邀请主持人进入分组为您提供帮助",
  POST_MSG_TO_ALL_TEAM: "向所有讨论组发送消息…",
  CHANGE_TEAM_HOST: "更改分组主持人",
  CHANGE_TEAM_HOST_TISP:
    "是否将当前参会人设为分组主持人，确认后将替换之前的分组主持人",
  LEAVE_TEAM: "离开讨论组",
  END_NAME: "结束",
  IS_END: "确认结束分组讨论吗？",
  END_SELECT: "结束后保留之前分组配置，可再次快速开始",
  BACK_MAIN: "返回主会场",
  BACK_MAIN_OR_LEAVE: "您可以返回主会场或直接离开会议",
  YOUR_BACK_MAIN: "您正在返回主会场",
  YOUR_JOIN_TEAM: "您正在进入分会场",
  TEAM_END_OR_YOUR_BACK_MAIN: "分组讨论已结束，您正在返回主会场",
  NO_DIVIDE_INTO_GROUP_USER: "未分组成员",
  NO_DIVIDE_USER: "暂无可分配的参会人",
  HOST_BUSY: "主持人正忙，请您稍后重试",
  HOST_CANCEL: "主持人已取消您分组主持人身份",
  CHANGE_TEAM: "主持人已将您移动至",
  YOU_SET_TEAM_HOST: "您已被设为分组主持人",
  MAIN_TEAM: "主会场",
  DELETE_ERROR: "删除失败,至少需要一个讨论组",
  PLEASE_INPUT_RIGHT_GROUP_NUMBER: "请输入正确的分组数量",
  NO_GROUP_POWER: "无分组权限，请和管理员联系",
  SET_SUCCESS: "设置成功",
  LATER: "稍后",
};
export default zh_cn;
